import { render } from "./LabelStockPage.vue?vue&type=template&id=07351856"
import script from "./LabelStockPage.vue?vue&type=script&lang=js"
export * from "./LabelStockPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__